module.exports = __webpack_public_path__ + "img/corpuls_corpuls3-4th-gen.514a4388.png";